import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();
const { projectCode } = PROJECT_CODE;

export async function getMatrixJson(callback){
    console.log("Call matrix");
    await firebase
        .database()
        .ref('/kavtek_lot_matrix/' + PROJECT_CODE.projectCode)
        .once('value', (snapshot) => {
            console.log("Calling callback");
            callback(snapshot.val());
        });
}

export async function setLotNumber(xindex, yindex, lotNumber){
    console.log(xindex + yindex +"Change lot number to " + lotNumber);

    await firebase.database().ref('/kavtek_lot_matrix/' + PROJECT_CODE.projectCode + '/' + xindex + '/' + yindex + '/lotNumber').set(lotNumber);
}

export async function setModel(xindex, yindex, modelName){
    console.log(xindex + yindex +"Change model number to " + modelName);

    await firebase.database().ref('/kavtek_lot_matrix/' + PROJECT_CODE.projectCode + '/' + xindex + '/' + yindex + '/model').set(modelName);
}

export async function setBlock(xindex, yindex, blockNumber){
    console.log(xindex + yindex +"Change blocl number to " + blockNumber);

    await firebase.database().ref('/kavtek_lot_matrix/' + PROJECT_CODE.projectCode + '/' + xindex + '/' + yindex + '/blockNumber').set(blockNumber);
}

export async function testAvailability(_lotNumber){
    var getAvailability = firebase.functions().httpsCallable('CheckModelAvailabilityOnLot');
    var thisBody = {
        lotNumber: _lotNumber,
        projectCode: PROJECT_CODE.projectCode,
    }
    getAvailability(thisBody);
}

export async function setUnavailable(modelName, elev,_lotNumber){
    console.log("SET UNAVAILABle");
    var setAvailability = firebase.functions().httpsCallable('setLotToMatrix');
    var thisBody = {model: modelName,
                    elevation: elev,
                    lotId: _lotNumber,
                    projectCode: PROJECT_CODE.projectCode,}
    setAvailability(thisBody);
}